import { gql } from '@/__generated__';

export const GATE_MOVEMENT_HISTORY_FRAGMENT = gql(`#graphql
  fragment GateMovementHistoryFragment on GateMovement {
    id
    gate {
      id
    }
    requestedBy {
      id
      name
    }
    requestedPosition
    startPosition
    finishPosition
    state
    messages {
      id
      type
    }
  }
`);
